import { action } from 'mobx';

export class EncryptStore {
    @action
    encriptar(cadena: string) {
     
        const password = 'bewcibiuchnioajs';
        const CryptoJS = require('crypto-js');
        const key = CryptoJS.enc.Utf8.parse(password);
        const textoEncriptado = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(cadena),
            key, { iv:  CryptoJS.enc.Utf8.parse('pljurdhuwospctra') }
        )
        return textoEncriptado.toString();
    }
}
export const encryptStore = new EncryptStore();
export default EncryptStore;
